import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerEdit, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { InputText } from '../componentes_generales/componentes_formulario/inputs/inputtext';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import styled from 'styled-components';
import global_axios  from '../../funciones_globales/interaccionapi';
import { cargarCatalogos , cargarCatalogosGenericoAsync, cargarCatalogos_Otros} from '../../funciones_globales/catalogos';
import { getItemDatosSesion } from '../../funciones_globales/manejosesion';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import moment from 'moment';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import { formatearFecha, formatearFechaMoment_a_String } from '../../funciones_globales/format';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import '../componentes_generales/componentes_formulario/contenedores/flexbox.css'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { validarPermisoAcceso } from '../../funciones_globales/utils';
import InputSearch from '../componentes_generales/componentes_formulario/inputs/inputsearch';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import ModalResponsive from '../componentes_generales/componentes_formulario/modals/modalresponsive';
//import { formatearLabel } from '../../funciones_globales/format';

//Notificacion
import { visualizarAlerta } from '../../actions/generales/act_gen01';

const BlockContainer = styled.div`
    pointer-events: none;
`;

const BotonLink = styled.button`
    color: #337ab7;
    border: none;
    border-radius: 0;
    font-weight: normal;
    background-color: transparent;
    border-color: transparent;
    &:hover {
        border-color: transparent;        
        text-decoration: underline;
    };
    &:focus {
        border-color: transparent;        
    };
    &:active {
        border-color: transparent;        
    };
    font-size: 11px;
    padding-left: ${props => props.margen_izq?props.margen_izq:'6'}px;
    padding-right: ${props => props.margen_der?props.margen_der:'6'}px;
    padding-top: ${props => props.margen_arriba?props.margen_arriba:'0'}px;
`;

const ContenedorModal = styled.div`
    margin-top: 20px;
    height: 75px;
    width: 350px;
`;


class FormCaja03 extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            recibo_estado: '',
            login_estado: null,

            //PARAMETROS

            daysDocParam: null,
            paramDiasChDia: null,

            boton_cambiarEfectivo: true,
            boton_cambiarCheque: true,

            //----OpSelects
            select_Cheque: true,
            select_Efectivo: true,

            operacion: 'M',

            //Inputs
            valor: '',
            recibo: '',
            usuario: '',
            clave: '',

            //DatePicker
            fecha: null,

            //Selects
            formaPago: [],
            formaPago_sel: '',
            fomapagoCheq_opt: [],
            fomapagoCheq_sel: null,
            banco: [],
            banco_sel: '',
            c_clientes_sel: null,
            c_vendedores_sel: null,

            //ActionButons default disabled      
            limpiar: true,
            anular: true,

            //PickerFecha
            fechaVencimiento: null,

            //Modal
            openModalEdicionbanco: false,
            catBancosRow_sel: null,
            catBancos: null,
            catBancos_sel: null,

            cuentaActual: '',
            cuentaCambio: '',

            //GRIDS
            grid_matrix_cambios: [],
            gridGridMatrix:[], //Para visualizar matriz de cambios
            grid_cheques: [],
            grid_efectivo_deposito: [],
            columnDefs_Efectivo:   [
                                        {   header: "",
                                            width: 30,
                                            checkboxSelection: true,
                                            suppressSorting: true,
                                            suppressMenu: true,
                                            suppressFilter: true,
                                            pinned: true                                                
                                        },
                                        {   header: "N°",
                                            field: "Secuencia",
                                            width: 30,
                                            type: "num_entero"                                                 
                                        },
                                        {   header: "Forma de pg.",
                                            field: "DescripcionPago",
                                            width: 120,
                                            type: "string"                                                 
                                        },
                                        {   header: "Cambio/FP.",
                                            field: "FP_cambiolabel",
                                            width: 90,
                                            type: "string"                                             
                                        },
                                        {   header: "Valor",
                                            field: "ValorRecaudado",
                                            width: 50,
                                            type: "num_decimal"                                           
                                        }                                    
                                    ],
            columnDefs_Cheque:     [
                                        {   header: "",
                                            width: 30,
                                            checkboxSelection: true,
                                            suppressSorting: true,
                                            suppressMenu: true,
                                            suppressFilter: true,
                                            pinned: true                                                
                                        },
                                        {   header: "N°",
                                            field: "Secuencia",
                                            width: 30,
                                            type: "num_entero"                                                 
                                        },                                        
                                        {   header: "Banco",
                                            field: "Banco",
                                            width: 120,
                                            type: "string"                                                                                   
                                        }, 
                                        {   header: "Cuenta",
                                            field: "Cuenta",
                                            width: 73,
                                            type: "string"
                                            //,editable: true                                                                  
                                        }, 
                                        {   header: "Doc.",
                                            field: "Cheque",
                                            width: 40,
                                            type: "num_entero"                                                                      
                                        },
                                        
                                        {   header: "Forma de pg.",
                                            field: "DescripcionPago",
                                            width: 120,
                                            type: "string"                                                 
                                        },
                                        {   header: "Cambio/FP.",
                                            field: "FP_cambiolabel",
                                            width: 120,
                                            type: "string"                                             
                                        },                                                                   
                                        {   header: "Fecha Ven.",
                                            field: "fechaOriginal",
                                            width: 75,
                                            type: "string"                                                                                  
                                        },                                   
                                        {   header: "Cambio/Fecha",
                                            field: "fechaCambio",
                                            width: 95,
                                            type: "string"                                                                                  
                                        },
                                        {   header: "Valor",
                                            field: "ValorRecaudado",
                                            width: 60,
                                            type: "num_decimal"                                                                           
                                        }                                    
                                    ],
            columnDefs_Matrix:  [
                                    {   header: "",
                                        width: 30,
                                        checkboxSelection: true,
                                        suppressSorting: true,
                                        suppressMenu: true,
                                        suppressFilter: true,
                                        pinned: true                                                
                                    },
                                    {   header: "Recibo",
                                        field: "recibo",
                                        width: 50,
                                        type: "num_entero"                                                 
                                    },
                                    {   header: "N°",
                                        field: "Secuencia",
                                        width: 30,
                                        type: "num_entero"                                                 
                                    },
                                    {   header: "Cuenta",
                                        field: "Cuenta",
                                        width: 73,
                                        type: "num_entero"                                                                   
                                    },
                                    {   header: "Banco",
                                        field: "Banco",
                                        width: 120,
                                        type: "string"                                                                                   
                                    },  
                                    {   header: "Doc.",
                                        field: "Cheque",
                                        width: 40,
                                        type: "num_entero"                                                                      
                                    },
                                    
                                    {   header: "Forma de pg.",
                                        field: "DescripcionPago",
                                        width: 120,
                                        type: "string"                                                 
                                    },
                                    {   header: "Cambio/FP.",
                                        field: "FP_cambiolabel",
                                        width: 120,
                                        type: "string"                                             
                                    },                                                                   
                                    {   header: "Fecha Ven.",
                                        field: "fechaOriginal",
                                        width: 75,
                                        type: "string"                                                                                  
                                    },                                   
                                    {   header: "Cambio/Fecha",
                                        field: "fechaCambio",
                                        width: 95,
                                        type: "string"                                                                                  
                                    },
                                    {   header: "Valor",
                                        field: "ValorRecaudado",
                                        width: 60,
                                        type: "num_decimal"                                                                           
                                    }                                    
                                ],
        };

    //GRID efectivo
    this.gridOptionsEfectivo = {
        context: {
            componentParent: this
        },  
        rowSelection: "single",        
        enableColResize: true,
        enableCellChangeFlash: true,
        onCellValueChanged: (event)=>{  
        }, 
        onRowDoubleClicked: (event)=>{
            event.data.FP_cambiolabel='';
            event.data.FP_cambio='';

            this.apiEF.refreshCells();
            this.delGridMatrix(event.data);
        }         
    };

    //GRID cheques
    this.gridOptionsCheques = {
        context: {
            componentParent: this
        },      
        rowSelection: "single", 
        singleClickEdit: true,       
        enableColResize: true,
        enableCellChangeFlash: true, 
        onRowSelected:((event)=>{
            if(event.node.selected===true){
                this.setState({ fomapagoCheq_sel: null, fechaVencimiento: null})
            }
        }),
        getRowStyle:(params)=>{
            if(params.data.Estado === 'N'){
                return {'background-color':'#fd3c3c'}
            }
        },
        onRowDoubleClicked: (event)=>{
            
            event.data.FP_cambiolabel='';
            event.data.FP_cambio='';
            event.data.fechaCambio='';

            this.apiChq.refreshCells();
            this.delGridMatrix(event.data);
            this.apiMatrix.refreshCells();
        },
        onCellEditingStarted: ((event)=>{
            if(event.colDef.field==='Cuenta'){
                if(event.data.Estado !== 'N'){
                    alert('- La forma de pago no esta bloqueada no se puede modificar el recibo');
                    this.apiChq.stopEditing();
                }
            }
        })     
    };

    //GRID Matrix
    this.gridOptionsMatrix = {
        context: {
            componentParent: this
        },      
        rowSelection: "multiple",        
        enableColResize: true,
        enableCellChangeFlash: true,
        suppressRowClickSelection:true,
    }

    this.onGridReadyEf = this.onGridReadyEf.bind(this);
    this.onGridReadyChq = this.onGridReadyChq.bind(this);
    this.onGridReadyMatrix = this.onGridReadyMatrix.bind(this);
    this.getRecibo = this.getRecibo.bind(this);
    this.changeRecibo = this.changeRecibo.bind(this);
    this.changeValueGeneral = this.changeValueGeneral.bind(this);
    this.cambioEfectivo = this.cambioEfectivo.bind(this);
    this.limpiarPantalla = this.limpiarPantalla.bind(this);
    this.limpiar = this.limpiar.bind(this);
    this.limpiarMatrixCambios = this.limpiarMatrixCambios.bind(this);                                                                                                                                                                                                                                                        
    this.guardarRecibo = this.guardarRecibo.bind(this);
    this.anularRecibo = this.anularRecibo.bind(this);
    this.cambioCheqFormaPago = this.cambioCheqFormaPago.bind(this);
    this.modificarValoresRecibidos = this.modificarValoresRecibidos.bind(this);
    this.cambiarBancosPorFila = this.cambiarBancosPorFila.bind(this);
    }

    immutablePush(array, newItem){
        return [ ...array, newItem ];  
    }

    immutableDelete(arr, index){
        var i = parseInt(index, 10);
        return arr.slice(0,i).concat(arr.slice(i+1));
    }

    onGridReadyEf(params) {
        this.apiEF = params.api;
        this.columnApiEF = params.columnApi;
    }

    onGridReadyChq(params) {
        this.apiChq = params.api;
        this.columnApiChq = params.columnApi;
    }

    onGridReadyMatrix(params){
        this.apiMatrix = params.api;
        this.columnApiMatrix = params.columnApi;
    }

    getOptions_Clientes(input, callback){        
        if (input.toString().length >= 2 ){
            let query = "?cadena_busq=" + input;     
            cargarCatalogosGenericoAsync('/clientes', query, callback)
        }
    }

    componentDidMount(){ 
            
        Promise.all([  
            cargarCatalogos('Banco'),        
            cargarCatalogos('FORMADPAGO'),
            cargarCatalogos_Otros('CAJA-DiasChqDia'),
            this.props.generar_LogAuditoriaIngresoForm('0503'),
        ])
        .then(([result_banco, result_formaPago, result_param ]) => {
            let fechaProceso = getFechaProcesoPorModulo('05');

            let arraytemp = [];
            let arrayFormasCheque = [];
            arraytemp = this.ajustarFormasPago(result_formaPago, 'E');
            arrayFormasCheque = this.ajustarFormasPago(result_formaPago, 'C');

            this.setState({catBancos: result_banco, formaPago: arraytemp, daysDocParam :result_param[0],
                fomapagoCheq_opt: arrayFormasCheque, fecha:moment(fechaProceso, 'DD/MM/YYYY')})
        })
        .catch((err)=> {
            console.log(err);
        });
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0503');
    }

    ajustarFormasPago(array, tipo){

        var result = [];

        switch(tipo){
            case 'E':
                array.forEach((FP)=>{
                    if( (parseInt(FP.value, 10) === 3) || (parseInt(FP.value, 10) === 8) ){
                        var item = {};
                        item.value = parseInt(FP.value, 10);
                        item.label = FP.label;        
                        result.push(item);
                    }
                })
                break;

            case 'C':
                array.forEach((FP)=>{
                    if(parseInt(FP.value,10) === 1 || parseInt(FP.value,10) === 2 || parseInt(FP.value,10) === 6 ){
                        var item = {};
                        item.value = parseInt(FP.value, 10);
                        item.label = FP.label;        
                        result.push(item);
                    }
                })
                break;
        
            default:
                break;
        }
        return result;
    }

    changeRecibo(event){

        const target = event.target;    
        const value = target.value;
        this.setState({recibo: value});

        //Eventos Clear
        this.setState({formaPago_sel: '',
            banco_sel: '',
            valor: '',
            c_clientes_sel: null,
            c_vendedores_sel: null,
            grid_cheques: [],
            grid_efectivo_deposito: [],
            fecha: moment(getItemDatosSesion('fechasistema'), 'DD/MM/YYYY')
        });
        
        this.switchActionButtons(true)
        this.clearEstados();

    }

    changeValueGeneral(event){    
        const target = event.target;       
        const name = target.name; 
        const value = target.type === 'checkbox' ? target.checked : target.value; 
        this.setState({            
        [name]: value
        });
    }

    cambioEfectivo(){
        var proceder = true;
        var errors = '';
        var selectedRows = [];
        
        selectedRows = this.apiEF.getSelectedRows();

        if(this.state.formaPago_sel === '' || this.state.formaPago_sel === null){
            proceder = false;
            errors+="- Seleccionar forma de pago a modificar\n"
        }else if(selectedRows.length === 0){
            proceder = false;
            errors+=" - No a seleccionado ningún documento\n"
        }else if(parseInt(selectedRows[0].FormaPago,10) === parseInt(this.state.formaPago_sel.value,10)){
            proceder = false;
            errors+="- No hay cambio a registrar\n";
        }

        if(proceder === true){
            //FP_cambio = '' //LABEL Forma de pago A CAMBIAR
            //FormaPago = ''; //VALOR Forma de pago actual
            selectedRows.forEach((SL)=>{
                this.state.grid_efectivo_deposito.forEach((EF)=>{
                    if(SL.Secuencia === parseInt(EF.Secuencia , 10)){
                        EF.FP_cambiolabel = this.state.formaPago_sel.label;
                        EF.FP_cambio = this.state.formaPago_sel.value;
                    }
                }) 
            })
            this.apiEF.refreshCells();
            //Crear y guardar matrix de cambios por recibo
            selectedRows[0].Cliente = this.state.c_clientes_sel.value;
            this.addGridMatrix(selectedRows[0]);
        }else{
           alert(errors) 
        }
    }

    //Cambios realizados x cada recibo
    cambioCheqFormaPago(){
        var errors = ''
        var proceder = true;
        var selectedRows = [];
        selectedRows = this.apiChq.getSelectedRows();

        //SELECIONAR UN CHEQUE A EDITAR
        if(selectedRows.length === 0){
            proceder = false;
            errors+="- No a seleccionado ningún documento\n"
        }else{
            //OBLIGATORIO FORMA DE PAGO A MOD
            if(this.state.fomapagoCheq_sel === '' || this.state.fomapagoCheq_sel === null){
                proceder = false;
                errors+="- Seleccionar la forma de pago a modificar\n"
                
            }else if(this.getVR('FP_cambio', selectedRows[0].Secuencia)===false){
                if(parseInt(selectedRows[0].FormaPago,10) === parseInt(this.state.fomapagoCheq_sel.value,10)){
                    proceder = false;
                    errors+="- No hay cambio a registrar\n"
                }
            }else if(parseInt(selectedRows[0].FP_cambio,10) === parseInt(this.state.fomapagoCheq_sel.value,10)){
                proceder = false;
                errors+="- No hay cambio a registrar\n"
            }
            
            /* 30/10/2018 - Eliminacion de validacion para efecto al cobro - impedia que se ingrese una fecha para esta forma de pago*/
            // if(this.state.fomapagoCheq_sel!==null){
            //     if( this.state.fomapagoCheq_sel.value === 2 && this.state.fechaVencimiento!==null){
            //         proceder = false;
            //         errors+='- Esta forma de pago no permite cambio de fecha\n'
            //     }
            // }
        }

        if(proceder===true){
            var statusAddRow = true;

            this.state.grid_cheques.forEach((CHQ)=>{
                if(selectedRows[0].Secuencia === parseInt(CHQ.Secuencia , 10)){
                    if(CHQ.FP_cambio !== CHQ.FormaPago){
                        /* Si entra setea la forma de pago en el grid (COLUMNA CAMBIO) */
                        CHQ.FP_cambio = this.state.fomapagoCheq_sel.value;      /* FormaPago_cambio = ''; VALOR Forma de pago A CAMBIAR */
                        CHQ.FP_cambiolabel = this.state.fomapagoCheq_sel.label; /* FP_cambio = ''; LABEL Forma de pago A CAMBIAR */

                        /* Validacion FP con fecha de vencimiento enviada */
                        if(this.state.fechaVencimiento!==null){
                            console.log('ENTRO A CAMBIO CON FECHA...');
                            let fechaRecibo = formatearFechaMoment_a_String(this.state.fecha).split('/');
                            let fechaInput = formatearFechaMoment_a_String(this.state.fechaVencimiento).split('/');
                            
                            //DIFF ENTRE FECHA RECIBO Y FECHA INGRESADA
                            let days = this.state.fechaVencimiento.diff(this.state.fecha, 'days');
                            
                            //PARAMETRO DE DIAS DE RANGO
                            let paramDays = parseInt(this.state.daysDocParam.value,10);

                            switch (this.state.fomapagoCheq_sel.value) {
                                case 1: 
                                    /* Cheque Dia DENTRO DE LA SEMANA DEL RECIBO INCLUIDO EL LUNES DE LA SIGUIENTE */

                                    if(days>=(paramDays*-1)){
                                        let start = moment(formatearFechaMoment_a_String(this.state.fecha),'DD/MM/YYYY').startOf('isoWeek').subtract(1, 'days');
                                        let end = moment(formatearFechaMoment_a_String(this.state.fecha),'DD/MM/YYYY').endOf('isoWeek').add(1, 'days');

                                        let ChqueDiaValid = this.state.fechaVencimiento.isBetween(start ,end)

                                        if(ChqueDiaValid===true){
                                            CHQ.fechaCambio = formatearFechaMoment_a_String(this.state.fechaVencimiento)
                                        }else{
                                            /* begin => establece la fecha del recibo - los dias cargardos desde el parametro  paramDays*/
                                            let begin = moment(formatearFechaMoment_a_String(this.state.fecha),'DD/MM/YYYY').subtract((paramDays), 'days'); 

                                            if(this.state.fechaVencimiento.isBetween(begin ,end)===true){
                                                /* 29/10/2018 SE PERMITE AÑADIR LA FECHA AUNQUE NO ESTE EN EL RANGO DE LUNES A LUNES 
                                                POR CONCEPTO QUE PUEDE LA FECHA DEL CHQDIA ESTAR (7) DIAS ATRAS DE LA FECHA DEL RECIBO */
                                                
                                                let alerta = {isVisible: true, tipo: 'warning', mensaje: '- Fecha insertada no esta dentro del rango para CHQ Día: Lunes al siguiente Lunes'};
                                                this.props.visualizarAlerta(alerta);
                                                CHQ.fechaCambio = formatearFechaMoment_a_String(this.state.fechaVencimiento)
                                            }else{

                                                CHQ.FP_cambio = '';
                                                CHQ.FP_cambiolabel = '';
                                                statusAddRow = false;
                                                let alerta = {isVisible: true, tipo: 'error', mensaje: '- Fecha inválida para la forma de pago seleccionada'};
                                                this.props.visualizarAlerta(alerta);                                   
                                            }
                                        }
                                    }else{                                        
                                        CHQ.FP_cambio = '';
                                        CHQ.FP_cambiolabel = '';
                                        statusAddRow = false;
                                        errors +=`- La fecha vencimiento no puede ser inferior con más de ${paramDays} días a la fecha del recibo.`
                                    }    
                                    break;
                                case 2:
                                    /* Efecto al cobro (MAYOR AL MES DEL RECIBO) */
                                    
                                    /* Obtiene el ultimo dia del mes segun la fecha del recibo */
                                    let lastDayOfMonthRecibo = moment(this.state.fecha, 'DD/MM/YYYY').add('months', 1).date(0);
                                    
                                    /* Compara si la fecha ingresada de efecto al cobro no esta dentro del mes según la fecha del recibo */
                                    let fechaValid = moment(formatearFechaMoment_a_String(this.state.fechaVencimiento),'DD/MM/YYYY').isAfter(lastDayOfMonthRecibo);
                                    
                                    if(fechaValid){
                                        CHQ.fechaCambio = formatearFechaMoment_a_String(this.state.fechaVencimiento)
                                        
                                    }else{
                                        /* Error por fecha invalida para EFECTO AL COBRO (MISMO MES QUE LA FECHA DEL RECIBO) */
                                        CHQ.FP_cambio = '';
                                        CHQ.FP_cambiolabel = ''; 
                                        statusAddRow = false;                                                 
                                        let alerta = {isVisible: true, tipo: 'error', mensaje: '- Fecha inválida para la forma de pago seleccionada'};
                                        this.props.visualizarAlerta(alerta);
                                    }
                                    break;
                                case 6: 
                                    /* Cheque Mes  (IGUAL AL MES DEL RECIBO) */                                                                     
                                    if(parseInt(fechaInput[1],10) === parseInt(fechaRecibo[1],10)){
                                        CHQ.fechaCambio = formatearFechaMoment_a_String(this.state.fechaVencimiento)
                                    }else{
                                        /* Diferente al mes del recibo */
                                        CHQ.FP_cambio = '';
                                        CHQ.FP_cambiolabel = '';
                                        statusAddRow = false;
                                        let alerta = {isVisible: true, tipo: 'error', mensaje: '- Fecha inválida para la forma de pago seleccionada'};
                                        this.props.visualizarAlerta(alerta);
                                    }
                                    break;                                
                                default:
                                    break;
                            }
                        }else{
                            console.log('ENTRO A CAMBIO SIN FECHA...');
                            /* Validacion por cambio por solo FP y el campo FechaOriginal */

                            let fechaRecibo = formatearFechaMoment_a_String(this.state.fecha).split('/');
                            let fechaCol = CHQ.fechaOriginal.split('/'); 
                            let fechaColM = moment(CHQ.fechaOriginal,'DD/MM/YYYY');

                            //DIFF ENTRE RECIBO Y FECHA COL
                            let days = fechaColM.diff(this.state.fecha, 'days');

                            //PARAMETRO DE DIAS EN RANGO
                            let paramDays = parseInt(this.state.daysDocParam.value,10);

                            switch (this.state.fomapagoCheq_sel.value) {
                                case 1: 
                                    /* Cheque Dia DENTRO DE LA SEMANA DEL RECIBO INCLUIDO EL LUNES DE LA SIGUIENTE */ 
                                    if(days>=(paramDays*-1)){

                                        let start = moment(formatearFechaMoment_a_String(this.state.fecha),'DD/MM/YYYY').startOf('isoWeek')
                                        let end = moment(formatearFechaMoment_a_String(this.state.fecha),'DD/MM/YYYY').endOf('isoWeek').add(1, 'days')
                                        let ChqueDiaValid = fechaColM.isBetween(start,end)

                                        if(ChqueDiaValid===true){
                                            CHQ.fechaCambio = '';
                                        }else{
                                            CHQ.FP_cambio = '';
                                            CHQ.FP_cambiolabel = '';
                                            statusAddRow = false;
                                            let alerta = {isVisible: true, tipo: 'error', mensaje: '- Fecha inválida para la forma de pago seleccionada'};
                                            this.props.visualizarAlerta(alerta);  
                                        }
                                    }else{
                                        CHQ.FP_cambio = '';
                                        CHQ.FP_cambiolabel = '';
                                        statusAddRow = false;
                                        errors +='- La fecha vencimiento no puede ser inferior a la fecha del recibo'  
                                    }
                                    break;
                                case 6: 
                                    /* Cheque Mes  (IGUAL AL MES DEL RECIBO) */
                                    if(parseInt(fechaCol[1],10) === parseInt(fechaRecibo[1],10)){
                                        CHQ.fechaCambio = ''
                                    }else{
                                        CHQ.FP_cambio = '';
                                        CHQ.FP_cambiolabel = '';
                                        statusAddRow = false;
                                        let alerta = {isVisible: true, tipo: 'error', mensaje: '- Fecha inválida para la forma de pago seleccionada'};
                                        this.props.visualizarAlerta(alerta);  
                                    }
                                    break;

                                case 2:
                                    /* Efecto al cobro (MAYOR AL MES DEL RECIBO) */
                                    
                                    /* Obtiene el ultimo dia del mes segun la fecha del recibo */
                                    let lastDayOfMonthRecibo = moment(this.state.fecha, 'DD/MM/YYYY').add('months', 1).date(0);
                                    
                                    /* Compara si la fecha ingresada de efecto al cobro no esta dentro del mes según la fecha del recibo */
                                    let fechaValid = fechaColM.isAfter(lastDayOfMonthRecibo);
                                    
                                    if(!fechaValid){
                                        /* Error por fecha invalida para EFECTO AL COBRO (MISMO MES QUE LA FECHA DEL RECIBO) */
                                        CHQ.FP_cambio = '';
                                        CHQ.FP_cambiolabel = ''; 
                                        statusAddRow = false;                                                 
                                        let alerta = {isVisible: true, tipo: 'error', mensaje: '- Fecha inválida para la forma de pago seleccionada'};
                                        this.props.visualizarAlerta(alerta);
                                    }
                                    break;
                            
                                default:
                                    break;
                            }
                        }
                    }else{
                        /* Impide que se ingrese la misma forma de pago */
                        statusAddRow = false;
                        errors += '- FP original y FP cambio deben ser diferentes.';
                    }
                    
                    if(errors!==''){
                        let alerta = {isVisible: true, tipo: 'error', mensaje: errors};
                        this.props.visualizarAlerta(alerta);
                    }
                }
            })

            this.setState({fomapagoCheq_sel: null, fechaVencimiento: null}, ()=>{
                this.apiChq.refreshCells();
            });
            

            //Crear y guardar matrix de cambios por recibo
            if(statusAddRow===true){
                //ADD COLUMN CLIENTE
                selectedRows[0].Cliente = this.state.c_clientes_sel.value;
                this.addGridMatrix(selectedRows[0]);
            }            
        }else{
            let alerta = {isVisible: true, tipo: 'error', mensaje: errors};
            this.props.visualizarAlerta(alerta); 
        }
    }

    //Adicion de modificaciones por recibo
    addGridMatrix(fila){
        console.log('FILA ADD: ', fila)
        let reemplazo = false;
    
        this.state.grid_matrix_cambios.forEach((MT, i)=>{            
            
            if(MT.recibo === fila.recibo && MT.Secuencia === fila.Secuencia){
                MT = fila
                reemplazo = true;
            }
        })

        if(reemplazo===false){
            var array = this.state.grid_matrix_cambios;
            array.push(fila)
            this.setState({grid_matrix_cambios: array, gridGridMatrix: this.immutablePush(this.state.gridGridMatrix, fila)},()=>{
                this.apiMatrix.selectAll();})
        }else{
            this.setState({gridGridMatrix: []}, ()=>{
                this.setState({gridGridMatrix: this.state.grid_matrix_cambios},()=>{
                    this.apiMatrix.selectAll();})
            })
        }
    }

    delGridMatrix(fila){
        let index = null
        let array = this.state.grid_matrix_cambios;
        let VisualArray = this.state.gridGridMatrix;
        let indexVisual = null;
        array.forEach((MT, i)=>{
            if(MT.recibo === fila.recibo && MT.Secuencia === fila.Secuencia){
                index = i
            }
        })
        if(index!==null){
            array.splice(index,1);;
            this.setState({grid_matrix_cambios: array})
        }

        VisualArray.forEach((MTV, i)=>{
            if(MTV.recibo === fila.recibo && MTV.Secuencia === fila.Secuencia){
                indexVisual = i
            }
        })
        if(indexVisual!==null){
            this.setState({gridGridMatrix: this.immutableDelete(this.state.gridGridMatrix, indexVisual)})
        }
        
    }

    //Obtener Valores Recibidos
    getVR(columna, serch){
        var existData = false;
        this.state.grid_cheques.forEach((CHQ)=>{
            if(serch === CHQ.Secuencia){
                if(CHQ.hasOwnProperty(columna)===true){
                    if(CHQ[columna]){
                        existData = true
                    }
                }
            }
        })
        return existData;
    }

    clearEstados(){
        this.switchOpControllersEfectivo(true);
        this.switchOpControllersCheque(true);
        this.setState({recibo_estado: ''});
    }

    //ACTION BUTTONS
    guardarRecibo(){

        var grid_envio = this.apiMatrix.getSelectedRows();
        var errors = "";
        var proceder = true;

        if(this.state.usuario==='' || this.state.clave===''){
            proceder = false;
            errors+='- Ingrese usuario y contraseña antes de guardar\n';
        }

        if(grid_envio.length <=0){
            proceder = false;
            errors+='- No existen cambios que guardar\n';
        }

        let operacion = validarPermisoAcceso(this.state.operacion, this.props.permiso)
        if(operacion.esValido===false){
            proceder = false;
            errors += '- '+operacion.msg+'\n';
        }

        if(proceder === true){
            let transaccion = window.confirm('¿Seguro de grabar la modificacion?');
            if(transaccion){
                let data = { user: this.state.usuario, pass: this.state.clave, codForm: this.props.formulario}
                this.authOperation(data).then((auth)=>{
                    
                    if(auth === true){
                        
                        data.grid_envio = grid_envio;
                        data.UsuarioAprobador = this.state.usuario;
                        data.Usuario = this.props.usuario;

                        let config_request = {
                            method: 'PUT',
                            url: 'caja/valoresrecibidos',
                            data
                        }
        
                        global_axios(config_request)
                        .then((response)=> {
                            
                            alert(response.data.msg);
                          
                            this.limpiar();
                            this.setState({grid_matrix_cambios: [], gridGridMatrix:[]})
                        })
                        .catch((error)=>{                
                            alert(error.response?error.response.data.msg:error.message);      
                        });
                    }
                })
                .catch((error)=>{
                    alert(error.response?error.response.data.msg:error.message);  
                });
            }
        }else{
            alert(errors)
        }
    }

    limpiar(){
        this.setState({formaPago_sel: '',
            banco_sel: '',
            valor: '',
            recibo: '',
            fecha: moment(getItemDatosSesion('fechasistema'), 'DD/MM/YYYY'),
            c_clientes_sel: '',
            c_vendedores_sel: '',
            grid_cheques: [],
            grid_efectivo_deposito: [],            
            fomapagoCheq_sel: null,
            usuario: '',
            clave: '',
            login_estado: null
        });
        this.switchActionButtons(true)
        this.clearEstados();
    }

    limpiarPantalla(){
        let msj = window.confirm('Esta acción limpiara todos los cambios realizados y la informacion actual de la pantalla')
        if(msj){
            this.limpiar();
            this.limpiarMatrixCambios();
        }
    }

    limpiarMatrixCambios(){
        this.setState({grid_matrix_cambios: [], gridGridMatrix:[]})
    }

    anularRecibo(){

        let transaccion = window.confirm('Esta apunto de anular el recibo #: '+this.state.recibo+' ¿Continuar?');
        if(transaccion){
            if(this.state.recibo_estado==='P'){

                let config_request = {
                    method: 'PUT',
                    url: 'caja/recibo/'+this.state.recibo
                }

                global_axios(config_request)
                .then((response)=> {
                    alert(response.data.msg);
                    this.limpiar();
                })
                .catch((error)=>{                
                    alert(error.response?error.response.data.msg:error.message);      
                });

            }else{
                alert("Solo puede anular recibos pendientes");
            }
        }
    }

    //METHODS
    //BLOQUEO DE BOTONES CAMBIAR false=>Activa/ true=>Desactiva 
    switchActionButtons(value){
        this.setState({limpiar: value});
        this.setState({anular: value});               
    }

    switchOpControllersCheque(value){
        this.setState({boton_cambiarCheque: value});
        this.setState({select_Cheque: value});
    }

    switchOpControllersEfectivo(value){
        this.setState({boton_cambiarEfectivo: value});
        this.setState({select_Efectivo: value});
    }

    //LOGIN METHOD
    authOperation(data){
        let config_request = {
            method: 'POST',
            url: '/validate/',
            data
        }
        return new Promise((resolve, reject) => {
        global_axios(config_request)
            .then((response)=>{
                resolve(response.data);
            })
            .catch((error)=>{
                reject(error);   
            })
        })
    }

    //LOADS METHODS
    getRecibo(){
        if(this.state.recibo === ''){
            alert("Digite un movimiento");
        }else if(parseInt(this.state.recibo,10) < 0 || this.state.recibo==='' ){
            alert("Movimiento no valido");
            this.limpiar();
        }else{
            global_axios({
                method: 'GET',
                url: 'caja/cobranza/recibo/'+this.state.recibo.toString()
            })
            .then((response)=> {
                
                var result = response.data;
                
                //Conversion y asignacion fecha
                let fecha = formatearFecha(result.Fecha);
                this.setState({fecha: moment(fecha, 'DD/MM/YYYY')});

                this.setState({
                    valor: result.Total_Pago,
                    recibo_estado: result.Estado
                })

                if(result.empCli!==null){
                    let data = {};
                    data.value = result.empCli.Cliente;
                    data.label = `${result.empCli.Nombre.trim().toUpperCase()} (${data.value})`;
                    this.setState({c_clientes_sel: data})
                }

                if(result.empVen!==null || result.empReca!==null){
                    let data = {};
                    data.value = result.empVen!==null?result.empVen.Vendedor:result.empReca!==null?result.empReca.Recaudador:'N/A';
                    data.label = result.empVen!==null?`${result.empVen.Nombre.trim().toUpperCase()} (${data.value})`:result.empReca!==null?`${result.empReca.Nombre.toUpperCase()} (${data.value})`:'N/A';
                    
                    this.setState({c_vendedores_sel: data})
                }
                
                Promise.all([
                    this.consultarDetalleCobranzaMovil(this.state.recibo)
                ])
                .then(([result]) =>{
                    console.log('ACCESO DATA: ',result)
                    var arrayCheque = [];
                    var arrayEfectivo = [];

                    arrayCheque = result.detalle_Cheque;
                    arrayEfectivo = result.detalle_Efectivo;

                    if(arrayCheque.length === 0 && arrayEfectivo.length === 0){
                        alert("El recibo "+this.state.recibo+" no reune los parametros de busqueda");
                    }else{
                        this.setState({grid_cheques: arrayCheque});
                        this.setState({grid_efectivo_deposito: arrayEfectivo});
                    }

                    //Control de proceso segun estado del cheque
                    if(this.state.recibo_estado==='P'){
                        this.setState({limpiar: false});
                        this.setState({anular: false});

                        //Desbloquear controles de operacion
                        if(this.state.grid_cheques.length > 0){
                            this.switchOpControllersCheque(false);
                        }else{
                            this.switchOpControllersCheque(true);
                        }

                        if(this.state.grid_efectivo_deposito.length > 0){
                            this.switchOpControllersEfectivo(false);
                        }else{
                            this.switchOpControllersEfectivo(true);
                        }
                    }else if(this.state.recibo_estado==='G'){
                        alert("Recibo # "+this.state.recibo+" Se encuentra guardado, no es posible modificar");
                        this.switchActionButtons(true);
                    }else if(this.state.recibo_estado==='B'){
                        alert("Recibo # "+this.state.recibo+" Se encuentra bloqueado.");
                        this.setState({limpiar: false});
                        this.setState({anular: false});
                    }               
                })
            })
            .catch((error)=>{                
                alert(error.response?error.response.data.msg:error.message);      
            });
        }
    }

    //Consulta de detalles de VR
    consultarDetalleCobranzaMovil(recibo){
        return new Promise((resolve, reject) => {
            global_axios({
            method: 'GET',
            url: 'caja/valoresrecibidos/recibo/' + recibo
            })
            .then((response)=> {      
                let valores_recibidos = response.data;
                var arrayEfectivo=[];
                var arrayCheque = [];
                var contenedor = {};

                valores_recibidos.forEach((VR)=>{

                    if(parseInt(VR.Forma_Pago,10) === 1 || parseInt(VR.Forma_Pago,10) === 2 || parseInt(VR.Forma_Pago,10) === 6 ){
                        var item = {};
                        item.recibo = recibo;
                        item.Secuencia = VR.Secuencia;
                        item.Cuenta = VR.cuenta!==null?VR.cuenta.trim():'';
                        item.Cheque = VR.cheque!==null?VR.cheque.trim():'';
                        item.FormaPago = VR.Forma_Pago!=='' || VR.Forma_Pago!==null?parseInt(VR.Forma_Pago,10):''; //--> Original FP
                        item.FP_cambiolabel = '' //LABEL FP A CAMBIAR
                        item.FP_cambio = '';    //VALOR FP A CAMBIAR 
                        item.DescripcionPago = VR.DescripcionPago;
                        item.Banco = VR.Banco;
                        item.Banco_num = VR.Banco_num; //--> Original Banco
                        //item.Banco_cambio = '' //LABEL BANCO A CAMBIAR
                        item.Banco_num_cambio = ''; //VALOR BANCO A CAMBIAR
                        item.fechaOriginal = formatearFecha(VR.Vencimiento_cheq) //--> Fecha Original
                        item.fechaCambio = '';  //Fecha A CAMBIAR 
                        item.Estado = VR.Estado;
                        item.ValorRecaudado = VR.ValorRecaudado;

                        arrayCheque.push(item);
                    }

                    if(parseInt(VR.Forma_Pago,10) === 3 || parseInt(VR.Forma_Pago,10) === 8){
                        // eslint-disable-next-line
                        var item = {};
                        item.recibo = recibo;
                        item.Secuencia = VR.Secuencia;
                        item.Cuenta = VR.cuenta!==null?VR.cuenta.trim():'';
                        item.Cheque = VR.cheque!==null?VR.cheque.trim():'';
                        item.Banco_num = VR.Banco_num; //--> Original Banco
                        item.FormaPago = VR.Forma_Pago;
                        item.DescripcionPago = VR.DescripcionPago;
                        item.FP_cambiolabel = '' //LABEL Forma de pago A CAMBIAR
                        item.FP_cambio = ''; //VALOR Forma de pago A CAMBIAR
                        item.ValorRecaudado = VR.ValorRecaudado;

                        arrayEfectivo.push(item);
                    }   
                })
                contenedor = { detalle_Efectivo: arrayEfectivo, detalle_Cheque: arrayCheque };
                resolve(contenedor); 
            })
            .catch((error)=> {
                reject(error.response.data.msg?error.response.data.msg:error.message);
            });
        });
    }

    //Proceso para desbloqueo de recibos moviles
    procesoDesbloqueoReciboPorCuenta(fila, banco, cuenta){
        return new Promise((resolve, reject) => {
            let data = {};

            data.Cliente = this.state.c_clientes_sel.value;
            data.CuentaOriginal = fila.Cuenta;
            data.CuentaCambio = cuenta!==fila.Cuenta?cuenta:null;            
            data.BancoOriginal = fila.Banco_num;
            data.BancoCambio = banco!==fila.Banco_num?banco:null;
            data.Cheque = fila.Cheque;
            data.FormaPago = fila.FormaPago;
            data.FechaVencimiento = fila.fechaOriginal;
            data.Usuario = this.props.usuario;
            data.Banco = banco;
            data.Cuenta = cuenta;

            let config_request = {
                method: 'PATCH',
                url: `/caja/recibo/${this.state.recibo}/secuencia/${fila.Secuencia}`,
                data 
            }

            global_axios(config_request)
            .then((response)=>{
                resolve(response)
            })
            .catch((err)=>{
                reject(err);
            });
        });
    }

    //Validacion por banco
    modificarValoresRecibidos(){
        let fila = this.apiChq.getSelectedRows()[0];
        console.log('FILA: ', fila)
        if(fila){
            //Adicion para deposito cuenta & Transferencias
            if(parseInt(fila.FormaPago,10)===1 || parseInt(fila.FormaPago,10)===2 || parseInt(fila.FormaPago,10)===6 || parseInt(fila.FormaPago,10)===4 || parseInt(fila.FormaPago,10)===5){
                this.setState({openModalEdicionbanco: !this.state.openModalEdicionbanco, catBancosRow_sel: null, cuentaCambio: '', catBancos_sel: null}, ()=>{
                    this.setState({catBancosRow_sel: fila.Banco_num, cuentaActual: fila.Cuenta})
                })
            }else{
                alert('Edición solo activa para bancos')
            }
        }else{
            alert("Seleccione una fila a editar")
        }
    }

    /* FUNCION DE VALIDACION */
    cambiarBancosPorFila(){
        let fila = this.apiChq.getSelectedRows()[0];
        var error = '';
        var proceder = true;

        let cuenta = this.state.cuentaCambio?this.state.cuentaCambio.toString().trim():fila.Cuenta?fila.Cuenta.toString().trim():'';
        let banco = this.state.catBancos_sel?this.state.catBancos_sel.value.toString().trim():fila.Banco_num;

        /* Validación por secuencia de cheque ya existente */
        let query = `clientes/${this.state.c_clientes_sel.value}/banco/${banco}/cuenta/${cuenta}/cheque/${fila.Cheque}`;

        Promise.all([
            this.validacionBancoCuentaPorCliente(this.state.c_clientes_sel.value, banco, cuenta),
            this.cargarObjetos(query)
        ]).then(([validCuenta, validSecChq])=>{
            /* VALIDACION CUENTA REGISTRADA */
            if(validCuenta.status === 204){
                this.setState({bancos_sel: null, cuenta: ""});
                proceder = false;
                error += '- Combinación banco, cuenta y cliente no se encuentra registrada.\n';
            }

            /* VALIDACION POR SEC CHQ REGISTRADA */
            if(validSecChq.status === 200 && proceder===true){
                this.setState({numCheque: ""});
                proceder = false;
                error += `- Secuencia de cheque #${this.state.numCheque} para el banco: ${this.state.bancos_sel.label} con Cta.: ${this.state.cuenta} ya se encuentra ingresado.\n`; 
            }

            if(proceder === false){
                alert(error);
            }else{
                this.modificarCuentaBanco(fila, banco, cuenta);
            }
        })
        .catch((error)=>{
            alert(error.response?error.response.data.msg:error.message);
        })
    }

    modificarCuentaBanco(fila, banco, cuenta){
        this.props.cambiar_VisualizacionLoading(true);
        this.procesoDesbloqueoReciboPorCuenta(fila, banco, cuenta)
        .then((response)=>{
            this.props.cambiar_VisualizacionLoading(false);
            let recibo = this.state.recibo;
            
            //MESAJE OPERACION
            alert(response.data.msg);
            
            //Limpieza de pantalla
            this.limpiar();
            this.limpiarMatrixCambios();
            
            //CARGA DE RECIBO
            this.setState({recibo: recibo, openModalEdicionbanco: false}
            ,()=>{
                this.getRecibo();
            })
        })
        .catch((error)=>{
            this.props.cambiar_VisualizacionLoading(false);
            alert(error.response?error.response.data.msg:error.message)
        })
    }

    validacionBancoCuentaPorCliente(cliente, banco, cuenta){
        return new Promise((resolve, reject)=>{
            global_axios.get(`clientes/${cliente}/banco/${banco}/cuenta/${cuenta}`)
            .then((response)=>{
                resolve(response);
            })
            .catch((err)=>{
                reject(err);
            });
        });
    }

    //Consulta DB
    cargarObjetos(ruta){
        return new Promise((resolve, reject) => {
            global_axios.get(ruta)
            .then((response)=>{
                resolve(response)
            })
            .catch((err)=>{
                reject(err);
            });
        });
    }

    render(){
        return(            
            <ContenedorForm porc_ancho={90}>
            <HeaderForm>
                <TituloForm>Modificación de formas de pago de recibo electronico</TituloForm>
            </HeaderForm>
                <CuerpoForm>
                    <ContainerEdit>
                        <Row>
                            <ContainerCol className='col-sm-2 col-sm-offset-10 col-sm-pull-10'>
                                <LabelForm>Recibo:</LabelForm>
                                <InputSearch tipoInput='number' nombre='recibo' valor={this.state.recibo} func_CambiarValor={this.changeRecibo} 
                                func_BuscarValor={this.getRecibo} func_OnFocus={this.limpiar} maxLength='6'/>
                            </ContainerCol>
                        </Row>
                    </ContainerEdit>
                    <Row>
                        <ContainerCol className='col-sm-4'>
                            <LabelForm>Cliente:</LabelForm>
                            <ReactSelectAsync value={this.state.c_clientes_sel} func_loadOptions={this.getOptions_Clientes} disabled={true}
                            func_onChange={(value)=>{this.setState({c_clientes_sel: value})}}/>
                        </ContainerCol>
                        <ContainerCol className='col-sm-3'>
                            <LabelForm>Vendedor:</LabelForm> 
                            <ReactSelectAsync value={this.state.c_vendedores_sel} func_loadOptions={this.getOptions_Clientes} disabled={true}
                            func_onChange={(value)=>{this.setState({c_vendedores_sel: value})}}/>                           
                        </ContainerCol>
                        <BlockContainer className='col-sm-2'>
                            <LabelForm>Fecha:</LabelForm>
                            <PickerFecha fechaSeleccionada={this.state.fecha} func_onChange={(fechaEscogida)=>{this.setState({fecha: fechaEscogida})}}/>
                        </BlockContainer>
                        <ContainerCol className='col-sm-1'>
                            <LabelForm>Valor:</LabelForm>
                            <InputText name='valor' value={this.state.valor} type="number" className='form-control input-sm' readOnly={true} placeholder='$' onChange={this.changeValueGeneral}/>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2'>
                            <BotonLink margen_arriba='27' type="button" onClick={this.modificarValoresRecibidos}>Cambiar Banco/Cuenta</BotonLink>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-4'>
                            <LabelForm>Efectivo/efectivo deposito:</LabelForm>
                            <AgGridRender altura='140px' data={this.state.grid_efectivo_deposito} columnas={this.state.columnDefs_Efectivo}
                            gridOptions={this.gridOptionsEfectivo} onGridReady={this.onGridReadyEf}/>
                            <div className='flex-container' >
                                <div className='flex-item-ajust'>
                                    <LabelForm>Forma pago:</LabelForm>
                                </div>
                                <div className='flex-item'>
                                    <ReactSelect options={ this.state.formaPago } disabled={this.state.select_Efectivo} value={this.state.formaPago_sel} func_onChange={(value)=>{this.setState({formaPago_sel: value})}} />
                                </div>
                                <div className='flex-item-ajust'>
                                    <BotonLink type="button" disabled={this.state.boton_cambiarEfectivo} onClick={this.cambioEfectivo}>Cambiar</BotonLink>
                                </div>               
                            </div>
                        </ContainerCol>
                        <ContainerCol className='col-sm-8'>
                            <LabelForm>Cheques:</LabelForm>
                            <AgGridRender altura='140px' data={this.state.grid_cheques} columnas={this.state.columnDefs_Cheque}
                            gridOptions={this.gridOptionsCheques} onGridReady={this.onGridReadyChq}/>
                            <div className='flex-container'>
                                <div className='flex-item'>
                                    <LabelForm>Forma de pago:</LabelForm>
                                </div>
                                <div className='flex-item'>
                                    <ReactSelect options={ this.state.fomapagoCheq_opt } disabled={this.state.select_Cheque} value={this.state.fomapagoCheq_sel} func_onChange={(value)=>{this.setState({fomapagoCheq_sel: value})}} />
                                </div>                               
                                <div className='flex-item'>
                                    <LabelForm>Fecha Vencimiento:</LabelForm>
                                </div>
                                <div className='flex-item'>
                                    <PickerFecha fechaSeleccionada={this.state.fechaVencimiento} disabled={this.state.modulos_sel===null?true:false} func_onChange={(fechaEscogida)=>{this.setState({fechaVencimiento: fechaEscogida});}}/>
                                </div>
                                <div className='flex-item-ajust'>
                                    <BotonLink type="button" disabled={this.state.boton_cambiarCheque} onClick={this.cambioCheqFormaPago}>Cambiar</BotonLink>
                                </div> 
                            </div>
                        </ContainerCol> 
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-9'>
                            <LabelForm>Cambios efectuados:</LabelForm>
                            <AgGridRender altura='140px' data={this.state.gridGridMatrix} columnas={this.state.columnDefs_Matrix}
                            gridOptions={this.gridOptionsMatrix} onGridReady={this.onGridReadyMatrix}/>
                        </ContainerCol>

                        <ContainerCol className='col-sm-3' margen_arriba='30'>
                            <Row>
                                <ContainerCol className='col-sm-12' margen_abajo='10'>
                                    <BotonLink margen_izq='0' margen_der='0' type="button" disabled={this.state.gridGridMatrix.length > 0?false:true} onClick={this.limpiarMatrixCambios}>Limpiar Cambios</BotonLink>
                                </ContainerCol>
                            </Row>                            
                            <Row>
                                <ContainerCol className='col-sm-4' margen_abajo='5'>
                                    <LabelForm>Usr. Ap.:</LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-sm-8' margen_abajo='5'>
                                    <InputText name='usuario' autoComplete='off' value={this.state.usuario} type="text" className='form-control input-sm' onChange={this.changeValueGeneral}/>
                                </ContainerCol>
                            </Row>
                            <Row>
                                <ContainerCol className='col-sm-4' margen_abajo='5'>
                                    <LabelForm>clave:</LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-sm-8' margen_abajo='5'>
                                    <InputText name='clave' autoComplete='off' value={this.state.clave} type="password" className='form-control input-sm' onChange={this.changeValueGeneral}/>
                                </ContainerCol>
                            </Row>                            
                        </ContainerCol>
                    </Row>
                    <Row>                  
                        <ContainerCol className='col-sm-12' margen_arriba="5">                            
                            <div className="btn-group pull-right">
                                <button type="submit" className='btn btn-primary btn-sm' disabled={this.state.gridGridMatrix.length>0?false:true} onClick={this.guardarRecibo}>
                                    <i className="fa fa-floppy-o fa-lg"></i> Guardar
                                </button>                            
                                <button type="button" className='btn btn-sm' disabled={this.state.limpiar} onClick={this.limpiarPantalla}>
                                    <i className="fa fa-trash-o fa-lg"></i> Limpiar
                                </button>
                                <button type="button" className='btn btn-sm btn-danger' disabled={this.state.anular} onClick={this.anularRecibo}>
                                    <i className="fa fa-times-circle fa-lg"></i> Anular
                                </button>                           
                            </div>
                        </ContainerCol>                  
                    </Row>
                </CuerpoForm>
                <ModalResponsive open={this.state.openModalEdicionbanco} onClose={()=>{this.setState({openModalEdicionbanco: false})}}>              
                    <HeaderForm>
                        <TituloForm>Edición de Banco/Cuenta</TituloForm>
                    </HeaderForm>
                    <ContenedorModal>
                        <Row>
                            <ContainerCol className='col-md-12'>                                
                                <ContainerCol className='col-md-6' margen_arriba='5'>
                                    <LabelForm>Banco actual: </LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-md-6 ' margen_arriba='5'>
                                    <ReactSelect options={ this.state.catBancos } disabled={true} value={this.state.catBancosRow_sel} func_onChange={(value)=>{this.setState({catBancosRow_sel: value})}} />
                                </ContainerCol>
                                <ContainerCol className='col-md-6'>
                                    <LabelForm>Banco a cambiar: </LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-md-6 '>
                                    <ReactSelect options={ this.state.catBancos } value={this.state.catBancos_sel} func_onChange={(value)=>{this.setState({catBancos_sel: value})}} />
                                </ContainerCol>
                            </ContainerCol>                            
                        </Row>
                        <Row>
                            <ContainerCol className='col-md-12'>                                
                                <ContainerCol className='col-md-6' margen_arriba='5'>
                                    <LabelForm>Cuenta actual: </LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-md-6 ' margen_arriba='5'>
                                    <InputText name='cuentaActual' disabled={true} value={this.state.cuentaActual} type="number" className='form-control input-sm'  onChange={this.changeValueGeneral}/>
                                </ContainerCol>
                                <ContainerCol className='col-md-6'>
                                    <LabelForm>Cuenta a cambiar: </LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-md-6 '>
                                    <InputText name='cuentaCambio' value={this.state.cuentaCambio} type="number" className='form-control input-sm'  onChange={this.changeValueGeneral}/>
                                </ContainerCol>
                            </ContainerCol>                            
                        </Row>
                        <Row margen_arriba='10'>                  
                            <ContainerCol className='col-md-12'>
                                <div className="btn-group pull-right">
                                    <button type="button" className='btn btn-primary btn-sm' disabled={this.state.catBancos_sel===null && this.state.cuentaCambio===""?true:false} onClick={this.cambiarBancosPorFila}>
                                        <i className="fa fa-floppy-o fa-lg"></i> Cambiar
                                    </button>         
                                </div>
                            </ContainerCol>                  
                        </Row>
                    </ContenedorModal>
                </ModalResponsive>
            </ContenedorForm>            
        )
    }
}

const mapStateToProps = ((state) => {
    return {permiso: state.sesion.valoresSesionForm.Permiso,
            puntoFacturacionSel: state.ventas.ptoFacturacionSel,
            usuario: state.sesion.valoresSesionForm.Usuario,
            IdRegAudit: state.sesion.valoresSesionForm.IdRegAudit,
            departamento : state.sesion.valoresSesionForm.Departamento,
            formulario: state.sesion.valoresSesionForm.Formulario, }
});
  
const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ cambiar_VisualizacionLoading, generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm, visualizarAlerta}, dispatch)
});
  
export default connect (mapStateToProps, mapDispatchToProps)(FormCaja03);